var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#heart_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26.75 6.792A9.055 9.055 0 0 0 20 9.867a9.055 9.055 0 0 0-6.75-3.075c-4.62 0-8.25 3.56-8.25 8.092 0 5.562 5.1 10.094 12.825 16.98L20 33.792l2.175-1.943C29.9 24.978 35 20.446 35 14.884c0-4.532-3.63-8.092-8.25-8.092Zm-6.6 22.88-.15.147-.15-.147C12.71 23.33 8 19.137 8 14.884c0-2.943 2.25-5.15 5.25-5.15 2.31 0 4.56 1.457 5.355 3.473h2.805c.78-2.016 3.03-3.473 5.34-3.473 3 0 5.25 2.207 5.25 5.15 0 4.253-4.71 8.446-11.85 14.788Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "heart_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#currentColor",
  d: "M0 0h40v40H0z"
})))));
export default SvgHeart;